import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, TextField, Switch } from '@material-ui/core'

import LanguageContext from "../../../contexts/LanguageContext"
import UserContext from "../../../contexts/UserContext"

import SuperAdminContext from "../../../contexts/SuperAdminContext"


import { TopBar, BottomBar, CenterContainer } from "./FormatsHelpers"

import EditableField from "./EditableField"
import EditableButton from "./EditableButton"

import EditorPopover from "../../ui/Admin/Formations/EditorPopover"

const FormatInputTexte = ({ actFormation, actIndex, format, setViewPlanCours, viewPlanCours, onlyContent, isEditor, sequenceSubMenu, setSequenceSubMenu }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const { manageFormatResponse, manageSlide } = useContext(UserContext)

  let superAdminContext = null
  if (isEditor) {
    superAdminContext = useContext(SuperAdminContext)
  }

  const [isAlreadyAnswer, setIsAlreadyAnswer] = useState(false)
  const [response, setResponse] = useState("")
  useEffect(() => {
    if (format?.isDone) {
      setIsAlreadyAnswer(true)
      if (format?.userChoice) {
        setResponse(format?.userChoice)
      } else {
        setResponse("")
      }
    } else {
      setIsAlreadyAnswer(false)
      setResponse("")
    }
  }, [format])


  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      height:onlyContent?"100%":"100vh",
      overflow:"hidden",
      gap:"10px"
    }}>
      { /* EDITOR ADMIN */}
      {isEditor &&
        <EditorPopover
          open={sequenceSubMenu}
        >
          <Box sx={{marginBottom:"2px", fontWeight:"bold"}}>Champ réponse</Box>
          <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
            <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
              <Switch
                sx={{marginLeft:"-5px"}}
                checked={format?.answers?.type === "textarea"?true:false}
                onChange={(e) => {
                  if (e.target.checked) {
                    superAdminContext?.onSequenceChange(
                      'answers',
                      { type: 'textarea' },
                      superAdminContext?.adminPlayerIndexes
                    )
                  } else {
                    superAdminContext?.onSequenceChange(
                      'answers',
                      { type: 'input' },
                      superAdminContext?.adminPlayerIndexes
                    )
                  }
                }}
                size="small"
                color="warning"
              />
              Textarea
            </Box>
          </Box>
          <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Image</Box>
          <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
            <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
              <Switch
                sx={{marginLeft:"-5px"}}
                checked={format?.image?true:false}
                onChange={(e) => {
                  if (e.target.checked) {
                    superAdminContext?.onSequenceChange(
                      'image',
                      { link: 'https://video.thelab.risinguparis.com/brain.svg', type: 'contain' },
                      superAdminContext?.adminPlayerIndexes
                    )
                  } else {
                    superAdminContext?.onSequenceChange(
                      'image',
                      null,
                      superAdminContext?.adminPlayerIndexes
                    )
                  }
                }}
                size="small"
                color="warning"
              />
              Afficher une image
            </Box>
            {format?.image &&
              <>
                <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
                  <Switch
                    sx={{marginLeft:"-5px"}}
                    checked={format?.image?.type === "contain"?false:true}
                    onChange={(e) => {
                      if (e.target.checked) {
                        superAdminContext?.onSequenceChange(
                          'image',
                          { link: format?.image?.link, type: 'cover' },
                          superAdminContext?.adminPlayerIndexes
                        )
                      } else {
                        superAdminContext?.onSequenceChange(
                          'image',
                          { link: format?.image?.link, type: 'contain' },
                          superAdminContext?.adminPlayerIndexes
                        )
                      }
                    }}
                    size="small"
                    color="warning"
                  />
                  Élargir l'image
                </Box>
                <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
                  <Box>
                    Url :
                  </Box>
                  <Box sx={{flex:1}}>
                    <input
                      value={format?.image?.link}
                      style={{width:"100%"}}
                      onChange={(e) => {
                        superAdminContext?.onSequenceChange(
                          'image',
                          { link: e.target.value, type: format?.image?.type },
                          superAdminContext?.adminPlayerIndexes
                        )
                      }}
                    />
                  </Box>
                </Box>
              </>
            }
          </Box>
        </EditorPopover>
      }
      { /* END EDITOR ADMIN */}

      <TopBar
        actFormation={actFormation}
        actIndex={actIndex}
        setViewPlanCours={setViewPlanCours}
        viewPlanCours={viewPlanCours}
        onlyContent={onlyContent}
      />
      <CenterContainer
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={onlyContent}
      >
        <Box sx={{
          width:"100%",
          maxHeight:["unset", "unset", "unset", "calc(100vh - 260px)"],
          display:"flex",
          flexDirection:["column", "column", "column", "row"],
          gap:["20px", "40px", "40px", "60px"],
          overflow:["unset", "unset", "unset", "hidden"],
        }}>
          {format?.image &&
            <Box sx={{
              flex: ["unset", "unset", "unset", 0.4],
            }}>
              <Box sx={{
                background:"white",
                width:"100%",
                border:"1px solid black",
                height:["250px", "400px", "400px", "unset"],
                aspectRatio:["unset", "unset", "unset", "520/450"],
                backgroundRepeat:"no-repeat",
                backgroundPosition:"center center",
                backgroundImage:"url("+format?.image?.link+")",
                backgroundSize:format?.image?.type === "cover" ? "cover" : "contain",
              }}>
              </Box>
            </Box>
          }
          <Box sx={{
            flex:format?.image ? ["unset", "unset", "unset", 0.6] : ["unset", "unset", "unset", 1],
            overflowX:"hidden",
            overflowY:["hidden", "hidden", "hidden", "auto"],
            display:"flex",
            flexDirection:"column",
          }}>
            <Box sx={{
              margin:'auto 0',
            }}>
              <EditableField
                field={format?.questions}
                type="questions"
                isEditor={isEditor}
                sx={{
                  color:"text.black",
                  fontSize:["26px", "42px", "42px", "46px"],
                  textAlign:format?.image ? ["center", "center", "center", "left"] : "center",
                }}
              />
              <Box sx={{
                marginTop:["20px", "30px", "30px", "50px"],
              }}>
                <TextField
                  fullWidth
                  multiline={format?.answers?.type === "textarea" ? true : false}
                  rows={5}
                  name="response"
                  type="text"
                  value={response}
                  variant="outlined"
                  placeholder={isEditor ? "" : languageValues?.formation?.yourAnswer[actLanguage]}
                  disabled={isAlreadyAnswer}
                  inputProps={{ maxLength: format?.answers?.type !== "textarea" ? 30 : "unset" }}
                  onChange={(e) => {
                    setResponse(e.target.value);
                  }}

                  sx={{
                    "&.MuiFormControl-root" : {
                      alignItems: format?.image ? ["center", "center", "center", "flex-start"] : "center",
                    },
                    "& .MuiInputBase-root" : {
                      height: format?.answers?.type !== "textarea" ? ["55px", "60px", "60px", "75px"] : "unset",
                      padding: "15px",
                      maxWidth:"600px",
                      fontSize:["16px", "19px", "19px", "22px"],
                      border:isAlreadyAnswer && "1px solid black",
                    },
                    "& .MuiInputBase-input" : {
                      padding: "0px",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </CenterContainer>
      <BottomBar
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={isEditor ? false : onlyContent}
        isEditor={isEditor}
        buttons={
          <EditableButton
            isEditor={isEditor}
            type="button"
            field={format?.button?.text}
            disabled={response.length <= 3}
            sx={{}}
            onClick={() => {
              manageFormatResponse(format, [{ key: 'isDone', value: true }, { key: 'userChoice', value: response }])
              manageSlide(1)
            }}
          />
        }
      />
    </Box>
  )
}


export default FormatInputTexte
